import React from 'react';
import './style.css';
import { AnimatedHeading, HoverText } from '../../shared/TextFx';
import bannerPlane from '../../assets/banner-plane.jpg';

const WhoWeAre = () => (
  <section className="who-we-are" id="who-we-are">
    {/* Full-bleed background image (decorative) */}
    <img className="who-we-are__bg" src={bannerPlane} alt="" aria-hidden="true" />
    <div className="who-we-are__overlay" aria-hidden="true" />

    <div className="who-we-are__container">
      <div className="who-we-are__card scale-block">
        <AnimatedHeading className="who-we-are__title" text="Who We Are" />

        <p className="who-we-are__subtitle">
          <span className="who-we-are__subtitle-bar" aria-hidden="true" />
          <span>Esquire Express</span>
          <span className="who-we-are__subtitle-bar" aria-hidden="true" />
        </p>

        <div className="opacity-block">
          <h4 className="who-we-are__sub-heading">
            Logistics experience built for what comes next.
          </h4>

          <p className="who-we-are__text">
            Esquire brings together experienced people, international coordination and specialised
            logistics solutions for shipments where timing and execution matter.
          </p>
          <p className="who-we-are__text">
            Today, we help customers navigate urgent and complex movements with active operational
            oversight from request through final delivery.
          </p>

         
        </div>
      </div>
    </div>
  </section>
);

export default WhoWeAre;
